import ContinentNav from './ContinentNav';
export default ContinentNav;



// WEBPACK FOOTER //
// ./src/components/Continent/ContinentNav/index.js